// Formatting for the Cash Flow report tab (EVA-274).
//
// Deliberately separate from CashFlowTable.jsx's formatters: the Audit tab shows
// 2 decimals, the report shows whole numbers (spec §2). Pure — no React, no DOM,
// no Handsontable — so the suppression rules can be unit-tested under bare node.

// Spec §2 says "0 as -". We keep the Audit tab's en dash: §2 also requires "the
// same currency, sign convention and thousands-separator formatting as the Cash
// Flow Audit tab", and the glyph is typography rather than meaning.
export const DASH = '–'

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

// Spec §2: "MMM-YYYY". Built from the ISO string rather than toLocaleDateString so
// the label is identical regardless of the viewer's browser locale.
export function formatMonthYear(isoDate) {
  if (!isoDate) return ''
  const match = /^(\d{4})-(\d{2})/.exec(String(isoDate))
  if (!match) return String(isoDate)
  const month = MONTHS[Number(match[2]) - 1]
  return month ? `${month}-${match[1]}` : String(isoDate)
}

// Spec §2: whole numbers, no decimals, 0 as a dash. The payload carries
// full-precision decimal strings; rounding happens here and only here, so the
// underlying values stay unrounded (§2, §8).
export function formatMoneyWhole(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return DASH
  const rounded = n.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })
  // -0 and values that round to zero both render as the dash.
  return isZeroString(rounded) ? DASH : rounded
}

// Spec §5 step 2: the suppression test runs AFTER whole-number display rounding.
// Deriving it from the formatter (rather than from a second rounding routine)
// makes the test literally true of what would have been displayed, and keeps the
// two from drifting apart.
export function isZeroDisplayed(value) {
  return formatMoneyWhole(value) === DASH
}

export function allZeroDisplayed(values) {
  return (values || []).every(isZeroDisplayed)
}

// "0" in the active locale, plus the "-0" the rounder can emit for small negatives.
const ZERO = (0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })

function isZeroString(formatted) {
  return formatted === ZERO || formatted === `-${ZERO}`
}
